import { render, staticRenderFns } from "./PrintQuickStatistics.vue?vue&type=template&id=77f6485c&scoped=true&"
import script from "./PrintQuickStatistics.vue?vue&type=script&lang=js&"
export * from "./PrintQuickStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PrintQuickStatistics.vue?vue&type=style&index=0&id=77f6485c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6485c",
  null
  
)

/* custom blocks */
import block0 from "./PrintQuickStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f6485c')) {
      api.createRecord('77f6485c', component.options)
    } else {
      api.reload('77f6485c', component.options)
    }
    module.hot.accept("./PrintQuickStatistics.vue?vue&type=template&id=77f6485c&scoped=true&", function () {
      api.rerender('77f6485c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/PrintQuickStatistics.vue"
export default component.exports